module.exports = "/static/assets/4e0d75550eca72a2eb76932cbd2cf0c2.gif";